import React, { Component } from "react";
import { Link } from "react-router-dom";
import i18n from "i18next";

class Breadcrumb extends Component {
  constructor(props) {
    super(props);
  }
  ucfirst = (str) => {
    var f = str.charAt(0).toUpperCase();
    return f + str.substr(1, str.length - 1);
  };

  render() {
    return (
      <>
        <div className="breadcrumbs uk-breadcrumb uk-flex-middle">

          {Object.keys(this.props.breadcrumbs).map((itm, inxB) => {
            console.log("object keys >> ", Object.keys(this.props.breadcrumbs).length, itm);
            const suffixLink = (parseInt(itm) !== Object.keys(this.props.breadcrumbs).length - 1)?"/list":"";
            return <div key={inxB}>
              <Link
                className="breadcrumbs__link"
                to={`/products/${
                  i18n.language + "/" + this.props.breadcrumbs[itm]["alias"]+suffixLink
                }`}
              >
                {
                  this.props.breadcrumbs[itm][
                    `name${this.ucfirst(i18n.language)}`
                  ]
                }
              </Link>
            </div>
          })}
        </div>
      </>
    );
  }
}

export default Breadcrumb;
